import { configureStore } from "@reduxjs/toolkit";
import appReducer from "./slice/appSlice";
import bannerReducer from './slice/bannerSlice';
import conditionReducer from "./slice/conditionSlice";
import slotReducer from "./slice/slotSlice";
import analyticsReducer from "./slice/analyticsSlice";
import unsavedReducer from "./slice/unsavedSlice";
import shopinfoReducer from "./slice/shopinfoSlice";
import missingEntitiesReducer from "./slice/missingEntitiesSlice";
import mobileReducer from "./slice/mobileSlice";

export const store = configureStore({
  reducer: {
    app: appReducer,
    conditions: conditionReducer,
    banner: bannerReducer,
    slots: slotReducer,
    analytics: analyticsReducer,
    unsaved: unsavedReducer,
    shopinfo: shopinfoReducer,
    missingEntities: missingEntitiesReducer,
    mobile: mobileReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
